import { useState } from 'react';
import constate from 'constate';

export function useUrlMediaPlayer() {
  const [url, setUrl] = useState<string | null>(null);
  const [options, setOptions] = useState<{
    title?: string;
    type?: string;
  }>({});

  const play = (url: string, options: any = {}) => {
    setUrl(url);
    setOptions(options);
  };

  const reset = () => {
    setUrl(null);
  };

  return {
    play,
    reset,
    url,
    options,
  };
}

export const [UrlMediaPlayerProvider, useUrlMediaPlayerCtx] = constate(useUrlMediaPlayer);
